import { render } from "./ImgCarousel.vue?vue&type=template&id=011c9cc6"
import script from "./ImgCarousel.vue?vue&type=script&lang=js"
export * from "./ImgCarousel.vue?vue&type=script&lang=js"

import "./ImgCarousel.vue?vue&type=style&index=0&id=011c9cc6&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__